import { useNavigate } from 'react-router-dom'
import { Safety } from '../classes/Safety'
import { VisitResponse } from '../types/auth'
import { ID } from '../types/models'
import { useApp } from './useApp'
import { useAuth } from './useAuth'
import { callAxios } from './useAxios'

/**
 * Log in as another user via the admin "visit" mechanism: fetch a token for the
 * target user, replace the session with it and land on the user's front page
 * with the installer level enabled. Returns false (and shows the error) when
 * the visit was refused.
 */
export const useVisitUser = (): ((userId: ID) => Promise<boolean>) => {

  const app = useApp()
  const { updateMe } = useAuth()
  const navigate = useNavigate()

  return async (userId: ID): Promise<boolean> => {
    const res = await callAxios<VisitResponse>({
      method: 'POST',
      url: '/auth/visit'
    }, { user_id: userId })

    if (!res.success) {
      app.addError(res)
      return false
    }

    Safety.set('token', res.data.token)
    Safety.set('refresh_token', res.data.refresh_token)
    await updateMe()
    Safety.set('installer-level', true)
    app.setInstallerLevel(true)
    navigate('/')
    return true
  }
}
